export enum SortType {
  NEW_OLD = 'newOld',
  OLD_NEW = 'oldNew',
  AZ = 'az',
  ZA = 'za',
  POPULAR = 'popular',
  UNPOPULAR = 'unpopular',
  REPLIES_ASC = 'repliesAsc',
  REPLIES_DESC = 'repliesDesc',
}

export type ExtendedSortType = string;

export function isExtendedSort(sort: string): sort is ExtendedSortType {
  return !Object.values(SortType).includes(sort as SortType);
}
